<template>
  <div class="panel panel-default panel-dashboard">
    <LoadingSpinner v-if="loading"/>
    <div class="panel-body" v-else>
      <div class="row" style="margin-bottom: 16px;">
        <div class="col-sm-6 col-sm-offset-18">
          <SelectWidget
              v-model="portalCompanyFilter"
              :nullable="true"
              :options="portalCompanyOptions"
              placeholder="(all companies)"
          />
        </div>
      </div>

      <table class="table table-striped table-condensed">
        <thead>
        <tr>
          <th class="col-xs-8">
            Title
          </th>

          <th class="col-xs-4">
            Publish At
          </th>

          <th class="col-xs-6">
            Company
          </th>

          <th class="col-xs-3">
            Page Views
          </th>

          <th class="col-xs-3">
            Impressions
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="article in articles">
          <td class="table__ellipsis">
            {{ article.title }}
          </td>

          <td>
            {{ article.publish_at | datetime }}
          </td>

          <td>
            {{ article.portal_company_name }}
          </td>

          <td>
            {{ article.article_render_count | number }}
          </td>

          <td>
            {{ article.article_impression_count | number }}
          </td>
        </tr>

        <tr>
          <td colspan="3">
            <b>
              Total
            </b>
          </td>

          <td>
            <b>
              {{ totalRenderCount | number }}
            </b>
          </td>

          <td>
            <b>
              {{ totalImpressionCount | number }}
            </b>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
  components: {LoadingSpinner, SelectWidget},

  props: {
    topic: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: null,
      loading: true,

      portalCompanyFilter: null,
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    articles(){
      const articles = this.topic.attributes.content_articles.map(contentArticle => ({
        ...contentArticle,
        ...(this.data.find(row => row.routable_id === contentArticle.id)||{article_render_count:0,article_impression_count:0})
      })).filter(contentArticle => !this.portalCompanyFilter || contentArticle.portal_company_id === this.portalCompanyFilter)

      articles.sort((a,b) => a.article_render_count < b.article_render_count ? 1 : -1)

      return articles
    },

    portalCompanyOptions() {
      return this.topic.attributes.content_articles.reduce((result, contentArticle) => {
        if(result.map(row => row.value).includes(contentArticle.portal_company_id)){
          return result
        }

        result.push({value: contentArticle.portal_company_id,label: contentArticle.portal_company_name})

        return result
      }, [])
    },

    totalRenderCount() {
      return this.articles.reduce((result, row) => result + row.article_render_count, 0)
    },

    totalImpressionCount() {
      return this.articles.reduce((result, row) => result + row.article_impression_count, 0)
    },
  },

  methods: {
    load() {
      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'article_render_count'},
          {name: 'article_impression_count'},
        ],
        dimensions: [
          {name: "routable_id"}
        ],
        filters: [
          {dimension: 'routable_id', operator: 'in', value: this.topic.attributes.content_articles.map(article => article.id)},
        ]
      }).then(response => {
        this.data = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
